<div class="card">
    <div class="card-body">
      <h3 class="card-title">Redirecting</h3>
      <p>If redirection is delayed, please use the link below</p>
      <div class="padded-div">
        <div class="padded-div d-grid gap-2 col-6 mx-auto">
          <button id="sign-in-q-identity"
              type="button"
              class="login-with-q-identity-btn"
              (click)="onSignInWithQIdentity()">
          </button>
        </div>
      </div>
    </div>
</div>